import React from 'react';
import { Online } from '@servahealth/serva-ui-kit';
import './App.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import AuthenticationContextProvider from '../Auth';
import {
    BrowserRouter as Router,
    Route,
    Routes,
} from 'react-router-dom';
import Login from './Login';
import ForgotMyPassword from './Login/ForgotPassword';
import Landing from './Login/Landing';
import Logout from './Login/Logout';

const queryClient = new QueryClient();

function App() {

    return (
        <QueryClientProvider client={queryClient}>
            <Online />
            <AuthenticationContextProvider>
                <Router>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/loginredirect" element={<Login />} />
                        <Route path="/logout" element={<Logout />} />
                        <Route path="/password_reset" element={<ForgotMyPassword />} />
                        <Route path="/landing" element={<Landing />} />
                        {/* <Route element={<Layout />}>
                            <Route path="/home" element={<Home />} />
                        </Route> */}
                    </Routes>
                </Router>
            </AuthenticationContextProvider>
        </QueryClientProvider>
    );
}

export default App;
